<template>
  <div>
    <ScaleLoader v-if="isLoading" :color="$vuetify.theme.primary" />
    <template v-else>
      <div class="py-3">
        <v-layout wrap>
          <v-flex xs3>
            <v-card class="pa-3">
              <div>{{ $t('total_user_receive_message') }}</div>
              <div
                style="
                  min-height: 200px;
                  font-size: 48px;
                  display: flex;
                  justify-content: flex-end;
                  align-items: flex-end;
                "
                class="primary--text"
              >
                {{ (data && data.totalUsers) || 0 }}
              </div>
            </v-card></v-flex
          >
          <v-flex xs6 class="px-3">
            <v-card class="pa-3">
              <div>Line Friend , Non-Line Friend</div>
              <div style="min-height: 200px">
                <template v-if="data && Object.keys(data).length > 0">
                  <apexchart
                    :key="chartKey"
                    type="donut"
                    :options="dashboardChartData.chartOptions"
                    :series="dashboardChartData.series"
                    :height="200"
                  ></apexchart>
                </template>
              </div>
            </v-card>
          </v-flex>
          <v-flex xs3>
            <v-card class="pa-3">
              <div>{{ $t('total messages') }}</div>
              <div
                style="
                  min-height: 200px;
                  font-size: 48px;
                  display: flex;
                  justify-content: flex-end;
                  align-items: flex-end;
                "
                class="primary--text"
              >
                {{ (data && data.totalMessages) || 0 }}
              </div></v-card
            >
          </v-flex>
        </v-layout>
      </div>
      <div class="py-3">
        <report-message-list
          :key="`report-user-message-branch_${timestamp}`"
          v-model="filterDataBeaconList"
        >
        </report-message-list>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ReportMessageList from '../ReportMessageList'
import beaconApi from '@/api/beacon'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import VueApexCharts from 'vue-apexcharts'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default {
  components: {
    ReportMessageList,
    apexchart: VueApexCharts,
    ScaleLoader
  },
  props: ['selectedDate'],
  data() {
    return {
      isLoading: false,
      items: [],
      beaconSelect: '',
      total_all_user: 0,
      data: [],
      currentSelectedDate: '',
      chartKey: 0,
      dashboardChartData: {
        series: [],
        chartOptions: {
          labels: ['Line Friend', 'Non-Line Friend'],
          chart: {
            type: 'donut',
            height: '200px'
          },
          plotOptions: {
            pie: {
              donut: {
                size: '70%'
              }
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  height: 200
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    timestamp() {
      return dayjs().format('x')
    },
    filterDataBeaconList() {
      return this.data && this.data.beacon ? this.data.beacon : {}
    }
  },
  watch: {
    selectedDate: function () {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchData()
    }
  },
  mounted() {
    if (this.selectedDate) {
      this.currentSelectedDate = this.selectedDate
      this.handleFetchData()
    }
  },
  methods: {
    async handleFetchData() {
      const vm = this
      try {
        vm.isLoading = true

        const config = {
          pageid: vm.selectedBot.pageid,
          data: {
            dateFrom: dayjs(vm.currentSelectedDate.start).format('YYYY-MM-DD'),
            dateTo: dayjs(vm.currentSelectedDate.end).format('YYYY-MM-DD')
          }
        }
        const response = await vm.getAnalyticsUserMessages(config)

        if (response && response.status === 200) {
          const tempData = response.data.data
          vm.data = tempData

          if (tempData && Object.keys(tempData).length > 0) {
            vm.dashboardChartData.series = [tempData.totalFriend, tempData.totalNonFriend]
          }
          vm.chartKey += 1
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        vm.isLoading = false
      }
    },
    async getAnalyticsUserMessages(payload) {
      try {
        const response = await beaconApi.getAnalyticsUserMessages({ config: payload })
        handleResponse(response)

        if (response && response.status === 200) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Dashboard.vue